import axios from "axios";
import { logout } from "../lib/auth";

import { dataDifine, EditDataDifine } from "../config/dataInterface";
import { CONST } from "../config/const";
import { makeParams } from "./common";

// 画面項目設定 - 選択肢ー取得
export async function getScreenColumnConfigSelects(id: string) {
  try {
    const path = "screenColumnConfigSelects";
    const params = { id };
    const response = await axios.get(CONST.apiUrl2 + path, {
      params,
    });
    if (response.data.fetch_data === "null") {
      return { sudDatas: [] };
    }
    return {
      sudDatas: response.data.fetch_data,
    };
  } catch (error) {
    return { sudDatas: [] };
    // logout();
  }
}

// 画面項目設定 - 選択肢一覧登録
export async function postScreenColumnConfigSelects(addData: {
  [key: string]: string | boolean | any[];
}) {
  try {
    const path = "screenColumnConfigSelects";
    const bodys = { addData };
    const response = await axios.post(CONST.apiUrl2 + path, {
      bodys,
    });
    return response.data.add;
  } catch (error) {
    // logout();
  }
}

// 独自項目の編集 - 値 - 編集前選択肢一覧取得
export async function getScreenColumnSelectEditBefore(
  screen_name: string,
  id: string,
  key: string
) {
  try {
    const path = "screenColumnConfigSelects/edit/before";
    const params = { screen_name, id, key };
    const response = await axios.get(CONST.apiUrl2 + path, {
      params,
    });
    const customerList = response.data.fetch_data as {
      option_select: string;
    }[];
    const editType = response.data.editType as string;
    return { customerList, editType };
  } catch (error) {
    return { customerList: [], editType: "" };
    // logout();
  }
}
